import { AlertTriangle } from 'lucide-react';
import { useI18n } from '../../contexts/I18nContext';
import type { ActorConflictGroup } from '../../lib/actorsApi';

/** "⚠ Conflict": the actor appeared at two or more clients of one industry. */
export function ConflictBadge({ groups }: { groups: ActorConflictGroup[] }) {
  const { t } = useI18n();
  if (groups.length === 0) return null;
  const title = groups
    .map((g) =>
      t('actors.conflictTooltip', {
        industry: g.industryName ?? '—',
        clients: g.clients.map((c) => c.clientName).join(', '),
      }),
    )
    .join('\n');
  return (
    <span
      title={title}
      className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800"
    >
      <AlertTriangle className="h-3.5 w-3.5" />
      {t('actors.conflictBadge')}
    </span>
  );
}
